import React, { Component, Fragment } from "react";
import PropTypes from "proptypes";
import Modal from "react-modal";
import RegistrationHeader from "./RegistrationHeader";
import Application from "../forms/Application";
import PendingApproval from "./../../screens/loginRegister/PendingApproval";
import TripList from "../triplist/TripList";
import MakeDeposit from "../forms/MakeDeposit";
import MakeDepositModal from "../forms/MakeDepositModal";

export default class Registration extends Component {
  state = {
    activeModal: null
  };

  componentWillMount() {
    Modal.setAppElement('body');
  }

  setParentTripValue = (tripIndex, name, value) => {
    this.props.user.trips[[tripIndex]][name] = value;
  };

  openModal = modalName => {
    this.setState({
      activeModal: modalName
    });
  };

  closeModal = () => {
    this.setState({
      activeModal: null
    });
  };

  render() {
    const {
      user,
      handleRouting,
      hasPaidDeposit,
      setAppState,
      getParentState,
      setParentState,
      history,
      addTripAddOn,
      deleteTripAddOn,
      userProps,
      isProcessing
    } = this.props;

    return (
      <div className="row">
        <RegistrationHeader
          user={user}
          hasPaidDeposit={hasPaidDeposit}
          setParentState={setParentState}
        />
        {user === undefined || Object.keys(user).length === 0 || (user.approved && user.approved === false && user.applicationStatus !== 'Applied' && user.applicationStatus !== 'Accepted') ? (
          <Application
            setAppState={setAppState}
            getParentState={getParentState}
            setParentState={setParentState}
            handleRouting={handleRouting}
            userProps={userProps}
          />
        ) : (
          ""
        )}
        {user && user.applicationStatus === 'Applied' && user.approved === false ? (
          <PendingApproval
            user={user}
            setAppState={setAppState}
            setParentState={setParentState}
            handleRouting={handleRouting}
          />
        ) : (
          ""
        )}
        {user &&
        user.approved &&
        (user.trips === undefined ||
          (user.pastTrips && user.pastTrips.length && !user.trips.length)) ? (
          <div className="col-md-12">
            <h2 className="h1-style returning-user-header">
              {user.pastTrips && user.pastTrips.length > 0 ? (
                <Fragment>
                  Welcome back, {user.name.split(" ")[0]}! Please select a trip!
                </Fragment>
              ) : (
                <Fragment>
                  Congrats, {user.name.split(" ")[0]}. You&#39;ve been accepted!
                  Please select a trip!
                </Fragment>
              )}
            </h2>
            <TripList
              user={user}
              setAppState={setAppState}
              handleRouting={handleRouting}
              setParentState={setParentState}
            />
          </div>
        ) : (
          ""
        )}
        {user &&
        user.approved &&
        user.trips &&
        user.trips.length &&
        !hasPaidDeposit ? (
          <MakeDeposit
            openModal={() => this.openModal("makeDepositModal")}
            userName={user.firstName}
            userId={user.id}
            trip={user.trips[0]}
            tripIndex={0}
            tripId={user.trips[0].id}
            history={history}
            availableAddOns={user.trips[0].availableAddOns}
            getParentState={getParentState}
            setParentState={setParentState}
            handleRouting={handleRouting}
            hasPaidDeposit={false}
            addTripAddOn={addTripAddOn}
            deleteTripAddOn={deleteTripAddOn}
            currentAddOns={user.trips[0].currentAddOns}
            user={user}
            userProps={userProps}
            setAppState={setAppState}
            setTripState={() => {}}
            setParentTripValue={this.setParentTripValue}
            isProcessing={isProcessing}
          />
        ) : (
          ""
        )}
        <Modal
          isOpen={this.state.activeModal === "makeDepositModal"}
          onRequestClose={this.closeModal}
          overlayClassName="overlay"
        >
          <MakeDepositModal closeModal={this.closeModal} />
        </Modal>
      </div>
    );
  }
}

Registration.propTypes = {
  handleRouting: PropTypes.func.isRequired,
  hasPaidDeposit: PropTypes.bool.isRequired,
  setAppState: PropTypes.func.isRequired,
  getParentState: PropTypes.func.isRequired,
  setParentState: PropTypes.func.isRequired,
  addTripAddOn: PropTypes.func.isRequired,
  deleteTripAddOn: PropTypes.func.isRequired,
  isProcessing: PropTypes.bool.isRequired,
  userProps: PropTypes.shape({
    emailAddress: PropTypes.string,
    birthdate: PropTypes.string,
    gender: PropTypes.string,
    nationality: PropTypes.string
  }),
};

Registration.defaultProps = {
  userProps: {}
};
